export const plantCalculationLoadingPlaceholder =
    {
        "cropKey": "",
        "isImperialMath": false,
        "yieldGoal": 0,
        "yieldUnit": "",
        "nutrientUnit": "",
        "nutrient": {
            "n": '',
            "p2o5": '',
            "k2o": '',
            "s": '',
            "p": '',
            "k": ''
        },
        "cropName": {
            "en": "Loading",
            "es": "Loading",
            "fr": "Loading",
            "pt": "Loading",
            "ru": "Loading",
            "zh": "Loading"
        }
    };

export const plantCalculationError =
    {
        "cropKey": "",
        "isImperialMath": false,
        "yieldGoal": 0,
        "yieldUnit": "",
        "nutrientUnit": "",
        "nutrient": {
            "n": 0,
            "p2o5": 0,
            "k2o": 0,
            "s": 0,
            "p": 0,
            "k": 0
        },
        "cropName": {
            "en": "Network Error",
            "es": "Network Error",
            "fr": "Network Error",
            "pt": "Network Error",
            "ru": "Network Error",
            "zh": "Network Error"
        }
    };


export const plantCalculationExample_1 =
    {
        "cropKey": "ww",
        "isImperialMath": true,
        "yieldGoal": 1,
        "yieldUnit": "bu/A",
        "nutrientUnit": "lb/A",
        "nutrient": {
            "n": 1.16,
            "p2o5": 0.48,
            "k2o": 0.29,
            "s": 0.1,
            "p": 0.21,
            "k": 0.24
        },
        "cropName": {
            "en": "Wheat (winter) grain",
            "es": "Trigo invernal, grano",
            "fr": "Blé d'hiver grain",
            "pt": "Trigo de inverno (grão)",
            "ru": "Пшеница (озимая), зерно",
            "zh": "冬小麦籽粒"
        }
    };


export const plantCalculationExample_2 =
    {
        "cropKey": "nn",
        "isImperialMath": true,
        "yieldGoal": 1,
        "yieldUnit": "bu/A",
        "nutrientUnit": "lb/A",
        "nutrient": {
            "n": 0.67,
            "p2o5": 0.35,
            "k2o": 0.25,
            "s": 0.08,
            "p": 0.15,
            "k": 0.21
        },
        "cropName": {
            "en": "Corn grain",
            "es": "Maíz, grano",
            "fr": "Mais grain",
            "pt": "Milho (grão)",
            "ru": "Кукуруза, зерно",
            "zh": "玉米"
        }
    };


export const plantCalculationExample_3 =
    {
        "cropKey": "tu",
        "isImperialMath": true,
        "yieldGoal": 1,
        "yieldUnit": "cwt/A",
        "nutrientUnit": "lb/A",
        "nutrient": {
            "n": 0.24,
            "p2o5": 0.08,
            "k2o": 0.5,
            "s": 0,
            "p": 0.03,
            "k": 0.42
        },
        "cropName": {
            "en": "Lettuce",
            "es": "Lechuga",
            "fr": "Lettue",
            "pt": "Alface",
            "ru": "Салат листовой",
            "zh": "莴苣"
        }
    };


export const plantCalculationExample_4 =
    {
        "cropKey": "ps",
        "isImperialMath": true,
        "yieldGoal": 1,
        "yieldUnit": "ton/A",
        "nutrientUnit": "lb/A",
        "nutrient": {
            "n": 33,
            "p2o5": 6.8,
            "k2o": 24,
            "s": 0,
            "p": 2.97,
            "k": 19.92
        },
        "cropName": {
            "en": "Peanut stover",
            "es": "Maní, rastrojo",
            "fr": "Arachide paille",
            "pt": "Amendoim (palha)",
            "ru": "Арахис, солома",
            "zh": "花生秸秆"
        }
    };

export const plantCalculationExample_5 =
    {
        "cropKey": "ws",
        "isImperialMath": false,
        "yieldGoal": 1,
        "yieldUnit": "t/ha",
        "nutrientUnit": "kg/ha",
        "nutrient": {
            "n": 21,
            "p2o5": 9.5,
            "k2o": 5.5,
            "s": 1.7,
            "p": 4.15,
            "k": 4.57
        },
        "cropName": {
            "en": "Wheat (spring) grain",
            "es": "Trigo primaveral, grano",
            "fr": "Blé grain de printemps",
            "pt": "Trigo de primavera (grão)",
            "ru": "Пшеница (яровая), зерно",
            "zh": "春小麦籽粒"
        }
    };


export const plantCatalogExample =
    {
        "databaseVersion": 2019,
        "databaseSource": "International Plant Nutrition Institute",
        "crops": [
            {
                "cropKey": "nn",
                "cropName": {
                    "en": "Corn grain",
                    "es": "Maíz, grano",
                    "fr": "Mais grain",
                    "pt": "Milho (grão)",
                    "ru": "Кукуруза, зерно",
                    "zh": "玉米"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "bu/A"
                }
            },
            {
                "cropKey": "tu",
                "cropName": {
                    "en": "Lettuce",
                    "es": "Lechuga",
                    "fr": "Lettue",
                    "pt": "Alface",
                    "ru": "Салат листовой",
                    "zh": "莴苣"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "cwt/A"
                }
            },
            {
                "cropKey": "ps",
                "cropName": {
                    "en": "Peanut stover",
                    "es": "Maní, rastrojo",
                    "fr": "Arachide paille",
                    "pt": "Amendoim (palha)",
                    "ru": "Арахис, солома",
                    "zh": "花生秸秆"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "cr",
                "cropName": {
                    "en": "Corn stover per unit of grain yield",
                    "es": "Maíz, rastrojo por unidad de rendimiento en grano",
                    "fr": "Paille de mais par unité de rendement grain",
                    "pt": "Milho (palha) por unidade de grão colhido",
                    "ru": "Кукуруза, солома (при планируемой урожайности зерна)",
                    "zh": "玉米秸秆的单位产量"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "bu/A"
                }
            },
            {
                "cropKey": "ww",
                "cropName": {
                    "en": "Wheat (winter) grain",
                    "es": "Trigo invernal, grano",
                    "fr": "Blé d'hiver grain",
                    "pt": "Trigo de inverno (grão)",
                    "ru": "Пшеница (озимая), зерно",
                    "zh": "冬小麦籽粒"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "bu/A"
                }
            },
            {
                "cropKey": "sg",
                "cropName": {
                    "en": "Soybean grain",
                    "es": "Soja, grano",
                    "fr": "Soja grain",
                    "pt": "Soja (grão)",
                    "ru": "Соя, зерно",
                    "zh": "大豆"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "bu/A"
                }
            },
            {
                "cropKey": "oj",
                "cropName": {
                    "en": "Oranges",
                    "es": "Naranjas",
                    "fr": "Oranges",
                    "pt": "Laranja",
                    "ru": "Апельсин",
                    "zh": "柑橘"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "by",
                "cropName": {
                    "en": "Soybean stover",
                    "es": "Soja, rastrojo",
                    "fr": "Soja paille",
                    "pt": "Soja (palha)",
                    "ru": "Соя, солома",
                    "zh": "大豆秸秆"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "og",
                "cropName": {
                    "en": "Oat grain",
                    "es": "Avena, grano",
                    "fr": "Avoine grain",
                    "pt": "Aveia (grão)",
                    "ru": "Овес, зерно",
                    "zh": "燕麦粒"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "bu/A"
                }
            },
            {
                "cropKey": "pn",
                "cropName": {
                    "en": "Peanut pods",
                    "es": "Maní, vainas",
                    "fr": "Arachide gousses",
                    "pt": "Amendoim (vagens)",
                    "ru": "Арахис, бобы",
                    "zh": "花生荚"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "gm",
                "cropName": {
                    "en": "Sorghum-sudan grass (DM)",
                    "es": "Sorgo - Pasto Sudán (MS)",
                    "fr": "Sorgho-herbe du Soudan (MS)",
                    "pt": "Capim Sudão (MS)",
                    "ru": "Сорго-суданковые гибриды (абсолютно сухое вещество)",
                    "zh": "高粱-苏丹草（干物质)"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "rs",
                "cropName": {
                    "en": "Rice straw",
                    "es": "Arroz, rastrojo",
                    "fr": "Riz paille",
                    "pt": "Arroz (palha)",
                    "ru": "Рис, солома",
                    "zh": "水稻秸秆"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "sc",
                "cropName": {
                    "en": "Sugarcane",
                    "es": "Caña de Azúcar",
                    "fr": "Canne à sucre",
                    "pt": "Cana de açúcar",
                    "ru": "Сахарный тростник",
                    "zh": "甘蔗"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "am",
                "cropName": {
                    "en": "Almonds, with shell",
                    "es": "Almendra, con cáscara",
                    "fr": "Amandes avec coquilles",
                    "pt": "Amêndoa (com casca)",
                    "ru": "Миндаль, орехи",
                    "zh": "带壳的杏仁"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "ys",
                "cropName": {
                    "en": "Rye straw",
                    "es": "Centeno, rastrojo",
                    "fr": "Seigle paille",
                    "pt": "Centeio (palha)",
                    "ru": "Рожь, солома",
                    "zh": "黑麦秸秆"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "pt",
                "cropName": {
                    "en": "Potato tuber zzzzzzz",
                    "es": "Papa, tubérculo",
                    "fr": "Pomme de terre tubercules",
                    "pt": "Batata (tubérculo)",
                    "ru": "Картофель, клубни",
                    "zh": "马铃薯块茎"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "cwt/A"
                }
            },
            {
                "cropKey": "af",
                "cropName": {
                    "en": "Alfalfa (DM)",
                    "es": "Alfalfa (MS)",
                    "fr": "Luzerne",
                    "pt": "Alfafa (DM)",
                    "ru": "Люцерна (абсолютно сухое вещество)",
                    "zh": "紫花苜蓿（干物质）"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "mg",
                "cropName": {
                    "en": "Millet grain",
                    "es": "Mijo, grano",
                    "fr": "Millet grain",
                    "pt": "Milheto (grão)",
                    "ru": "Просо обыкновенное, зерно",
                    "zh": "粟"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "bu/A"
                }
            },
            {
                "cropKey": "tm",
                "cropName": {
                    "en": "Tomato",
                    "es": "Tomate",
                    "fr": "Tomate",
                    "pt": "Tomate",
                    "ru": "Томат",
                    "zh": "番茄"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "yg",
                "cropName": {
                    "en": "Ryegrass (DM)",
                    "es": "Raigrás (MS)",
                    "fr": "Ray-grass (DM)",
                    "pt": "Centeio (MS)",
                    "ru": "Райграс пастбищный (абсолютно сухое вещество)",
                    "zh": "黑麦草（干物质）"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "mo",
                "cropName": {
                    "en": "Mint oil",
                    "es": "Menta, aceite",
                    "fr": "Menthe huile",
                    "pt": "Menta (óleo)",
                    "ru": "Мята, масло",
                    "zh": "薄荷油"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "lb/A"
                }
            },
            {
                "cropKey": "lu",
                "cropName": {
                    "en": "Bluegrass (DM)",
                    "es": "Pasto azul (MS)",
                    "fr": "Pâturin",
                    "pt": "Grama azul (MS)",
                    "ru": "Мятлик луговой (абсолютно сухое вещество)",
                    "zh": "早熟禾（干物质）"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "vh",
                "cropName": {
                    "en": "Vetch (DM)",
                    "es": "Vicia (MS)",
                    "fr": "Vesce (MS)",
                    "pt": "Ervilha (MS)",
                    "ru": "Вика (абсолютно сухое вещество)",
                    "zh": "野豌豆（干物质）"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "rg",
                "cropName": {
                    "en": "Rice grain",
                    "es": "Arroz, grano",
                    "fr": "Riz grain",
                    "pt": "Arroz (grão)",
                    "ru": "Рис, зерно",
                    "zh": "稻粒"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "bu/A"
                }
            },
            {
                "cropKey": "bd",
                "cropName": {
                    "en": "Beans, dry",
                    "es": "Poroto seco",
                    "fr": "Haricots, sec",
                    "pt": "Feijão (seco)",
                    "ru": "Фасоль, зерно",
                    "zh": "干豆子"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "bu/A"
                }
            },
            {
                "cropKey": "sy",
                "cropName": {
                    "en": "Soybean hay (DM)",
                    "es": "Heno de Soja (MS)",
                    "fr": "Soja foin (MS)",
                    "pt": "Soja, feno (MS)",
                    "ru": "Соя, сено (абсолютно сухое вещество)",
                    "zh": "黄豆草(干物质）"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "ot",
                "cropName": {
                    "en": "Oat straw",
                    "es": "Avena, rastrojo",
                    "fr": "Avoine paille",
                    "pt": "Aveia (palha)",
                    "ru": "Овес, солома",
                    "zh": "燕麦秸秆"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "ws",
                "cropName": {
                    "en": "Wheat (spring) grain",
                    "es": "Trigo primaveral, grano",
                    "fr": "Blé grain de printemps",
                    "pt": "Trigo de primavera (grão)",
                    "ru": "Пшеница (яровая), зерно",
                    "zh": "春小麦籽粒"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "bu/A"
                }
            },
            {
                "cropKey": "gt",
                "cropName": {
                    "en": "Sorghum stover",
                    "es": "Sorgo, rastrojo",
                    "fr": "Sorgho paille",
                    "pt": "Sorgo (palha)",
                    "ru": "Сорго, солома",
                    "zh": "高粱秸秆"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "bs",
                "cropName": {
                    "en": "Barley straw",
                    "es": "Cebada, rastrojo",
                    "fr": "Orge paille",
                    "pt": "Cevada (palha)",
                    "ru": "Ячмень, солома",
                    "zh": "大麦秆"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "fu",
                "cropName": {
                    "en": "Fescue grass (DM)",
                    "es": "Festuca (MS)",
                    "fr": "Fétuque",
                    "pt": "Festuca (MS)",
                    "ru": "Овсяница тростниковая (абсолютно сухое вещество)",
                    "zh": "牛毛草（干物质）"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "gb",
                "cropName": {
                    "en": "Sugarbeet roots",
                    "es": "Remolacha azucarera, raíz",
                    "fr": "Betterave à sucre",
                    "pt": "Beterraba açucareira (raízes)",
                    "ru": "Сахарная свекла, корнеплоды",
                    "zh": "甜菜根"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "py",
                "cropName": {
                    "en": "Peas, dry",
                    "es": "Arvejas, secas",
                    "fr": "Pois, secs",
                    "pt": "Pera (seca)",
                    "ru": "Горох, зерно",
                    "zh": "干豌豆"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "bu/A"
                }
            },
            {
                "cropKey": "ca",
                "cropName": {
                    "en": "Canola grain",
                    "es": "Colza, grano",
                    "fr": "Colza grain",
                    "pt": "Canola (grão)",
                    "ru": "Рапс, семена",
                    "zh": "油菜籽"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "bu/A"
                }
            },
            {
                "cropKey": "fs",
                "cropName": {
                    "en": "Flax straw per unit of grain yield",
                    "es": "Lino, rastrojo por unidad de rendimiento en grano",
                    "fr": "Lin paille par unité de rendement grain",
                    "pt": "Linho (palha) por unidade de grão colhido",
                    "ru": "Лен, солома (при планируемой урожайности семян)",
                    "zh": "亚麻秸秆的单位产量"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "bu/A"
                }
            },
            {
                "cropKey": "fl",
                "cropName": {
                    "en": "Sunflower grain",
                    "es": "Girasol, grano",
                    "fr": "Tournesol grain",
                    "pt": "Girassol (grão)",
                    "ru": "Подсолнечник, семена",
                    "zh": "葵花籽"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "cwt/A"
                }
            },
            {
                "cropKey": "ry",
                "cropName": {
                    "en": "Rye grain",
                    "es": "Centeno, grano",
                    "fr": "Seigle grain",
                    "pt": "Centeio (grão)",
                    "ru": "Рожь, зерно",
                    "zh": "黑麦"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "bu/A"
                }
            },
            {
                "cropKey": "ak",
                "cropName": {
                    "en": "Alsike clover (DM)",
                    "es": "Trébol híbrido (MS)",
                    "fr": "Trèfle hybride",
                    "pt": "Trifolium hybridum (MS)",
                    "ru": "Клевер розовый (абсолютно сухое вещество)",
                    "zh": "瑞士三叶草（干物质）"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "fw",
                "cropName": {
                    "en": "Sunflower stover per unit of grain yield",
                    "es": "Girasol, rastrojo por unidad de rendimiento en grano",
                    "fr": "Tournesol paille par unité de rendement grain",
                    "pt": "Girassol (palha) por unidade de grão colhido",
                    "ru": "Подсолнечник, стебли (при планируемой урожайности семян)",
                    "zh": "葵花秸秆单位产量"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "cwt/A"
                }
            },
            {
                "cropKey": "gp",
                "cropName": {
                    "en": "Grapes",
                    "es": "Uvas",
                    "fr": "Raisins",
                    "pt": "Uva",
                    "ru": "Виноград",
                    "zh": "葡萄"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "ms",
                "cropName": {
                    "en": "Millet straw",
                    "es": "Mijo, rastrojo",
                    "fr": "Millet paille",
                    "pt": "Milheto (palha)",
                    "ru": "Просо обыкновенное, солома",
                    "zh": "粟秸秆"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "we",
                "cropName": {
                    "en": "Sunflower stover",
                    "es": "Girasol, rastrojo",
                    "fr": "Tournesol paille",
                    "pt": "Girassol (palha)",
                    "ru": "Подсолнечник, стебли и корзинки",
                    "zh": "葵花秸秆"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "rc",
                "cropName": {
                    "en": "Reed canary grass (DM)",
                    "es": "Alpiste (MS)",
                    "fr": "Alpiste roseau",
                    "pt": "Alpiste (MS)",
                    "ru": "Двукисточник тростниковый (абсолютно сухое вещество)",
                    "zh": "利甘草（干物质）"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "op",
                "cropName": {
                    "en": "Cantaloupe",
                    "es": "Cantalupo",
                    "fr": "Cantaloup",
                    "pt": "Meloa",
                    "ru": "Дыня-канталупа",
                    "zh": "哈密瓜"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "gv",
                "cropName": {
                    "en": "Sorghum stover per unit of grain yield",
                    "es": "Sorgo, rastrojo por unidad de rendimiento en grano",
                    "fr": "Sorgho paille par unité de rendement grain",
                    "pt": "Sorgo (palha) por unidade de grão colhido",
                    "ru": "Сорго, солома (при планируемой урожайности зерна)",
                    "zh": "高粱秸秆的单位产量"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "bu/A"
                }
            },
            {
                "cropKey": "tl",
                "cropName": {
                    "en": "Tobacco leaves",
                    "es": "Tabaco, hojas",
                    "fr": "Tabac feuilles",
                    "pt": "Tabaco (folhas)",
                    "ru": "Табак, листья",
                    "zh": "烟叶"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "cwt/A"
                }
            },
            {
                "cropKey": "fg",
                "cropName": {
                    "en": "Flax grain",
                    "es": "Lino, grano",
                    "fr": "Lin grain",
                    "pt": "Linho (grão)",
                    "ru": "Лен-долгунец, семена",
                    "zh": "麻粒"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "bu/A"
                }
            },
            {
                "cropKey": "wg",
                "cropName": {
                    "en": "Switchgrass (DM)",
                    "es": "Pasto Varilla (MS)",
                    "fr": "Panic raide (MS)",
                    "pt": "Panicum virgatum (MS)",
                    "ru": "Просо прутьевидное (абсолютно сухое вещество)",
                    "zh": "柳枝稷（干物质）"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "pu",
                "cropName": {
                    "en": "Prunes",
                    "es": "Ciruelas",
                    "fr": "Pruneaux",
                    "pt": "Ameixa",
                    "ru": "Слива, чернослив",
                    "zh": "西梅干"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "cd",
                "cropName": {
                    "en": "Red clover (DM)",
                    "es": "Trébol rojo (MS)",
                    "fr": "Trèfle rouge",
                    "pt": "Trevo vermelho (MS)",
                    "ru": "Клевер луговой (абсолютно сухое вещество)",
                    "zh": "红三叶草（干物质）"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "gr",
                "cropName": {
                    "en": "Orchardgrass (DM)",
                    "es": "Pasto ovillo (MS)",
                    "fr": "Dactyle pelotonne",
                    "pt": "Dátilo (MS)",
                    "ru": "Ежа сборная (абсолютно сухое вещество)",
                    "zh": "果园草（干物质）"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "pg",
                "cropName": {
                    "en": "Wheat straw per unit of grain yield",
                    "es": "Trigo, rastrojo por unidad de rendimiento en grano",
                    "fr": "Blé paille par unité de rendement grain",
                    "pt": "Trigo (palha) por unidade de grão colhido",
                    "ru": "Пшеница, солома (при планируемой урожайности зерна)",
                    "zh": "小麦秸秆单位产量"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "bu/A"
                }
            },
            {
                "cropKey": "gh",
                "cropName": {
                    "en": "Sorghum grain",
                    "es": "Sorgo, grano",
                    "fr": "Sorgho grain",
                    "pt": "Sorgo (grão)",
                    "ru": "Сорго, зерно",
                    "zh": "高粱"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "bu/A"
                }
            },
            {
                "cropKey": "pr",
                "cropName": {
                    "en": "Pears",
                    "es": "Peras",
                    "fr": "Poires",
                    "pt": "Pera",
                    "ru": "Груша",
                    "zh": "梨"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "br",
                "cropName": {
                    "en": "Barley grain",
                    "es": "Cebada, grano",
                    "fr": "Orge grain",
                    "pt": "Cevada (grão)",
                    "ru": "Ячмень, зерно",
                    "zh": "大麦"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "bu/A"
                }
            },
            {
                "cropKey": "bp",
                "cropName": {
                    "en": "Barley straw per unit of grain yield",
                    "es": "Cebada, rastrojo por unidad de rendimiento en grano",
                    "fr": "Orge paille par unité de rendement grain",
                    "pt": "Cevada (palha) por unidade de grão colhido",
                    "ru": "Ячмень, солома (при планируемой урожайности зерна)",
                    "zh": "大麦秸秆单位产量"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "bu/A"
                }
            },
            {
                "cropKey": "bt",
                "cropName": {
                    "en": "Sugarbeet tops",
                    "es": "Remolacha azucarera, parte aérea",
                    "fr": "Betterave à sucre (inflorescence terminale)",
                    "pt": "Beterraba açucareira (parte aérea)",
                    "ru": "Сахарная свекла, ботва",
                    "zh": "甜菜根上部分"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "cl",
                "cropName": {
                    "en": "Cotton lint and seed",
                    "es": "Fibra de Algodón",
                    "fr": "Fibre de coton",
                    "pt": "Algodão (fibra)",
                    "ru": "Хлопчатник, волокно",
                    "zh": "皮棉"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "bale/A"
                }
            },
            {
                "cropKey": "cb",
                "cropName": {
                    "en": "Cabbage",
                    "es": "Calabaza",
                    "fr": "Chou",
                    "pt": "Repolho",
                    "ru": "Капуста белокочанная",
                    "zh": "卷心菜"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "cwt/A"
                }
            },
            {
                "cropKey": "bw",
                "cropName": {
                    "en": "Buckwheat",
                    "es": "Alforfón",
                    "fr": "Sarrasin",
                    "pt": "Trigo sarraceno",
                    "ru": "Гречиха",
                    "zh": "荞麦"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "bu/A"
                }
            },
            {
                "cropKey": "bc",
                "cropName": {
                    "en": "Broccoli",
                    "es": "Brocoli",
                    "fr": "Broccoli",
                    "pt": "Brócolis",
                    "ru": "Брокколи",
                    "zh": "西兰花"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "cwt/A"
                }
            },
            {
                "cropKey": "pv",
                "cropName": {
                    "en": "Potato, above-ground stems and leaves",
                    "es": "Falso Jazmín, tallos aéreos y hojas",
                    "fr": "Pomme de terre, tiges et feuilles sur sol",
                    "pt": "Batata, caules e folhas acima do solo",
                    "ru": "Картофель, ботва",
                    "zh": "马铃薯，地上茎和叶"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "cwt/A"
                }
            },
            {
                "cropKey": "ff",
                "cropName": {
                    "en": "Safflower seed",
                    "es": "Cártamo, semilla",
                    "fr": "Carthame",
                    "pt": "Açafrão (sementes)",
                    "ru": "Сафлор, семена",
                    "zh": "红花籽"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "cwt/A"
                }
            },
            {
                "cropKey": "me",
                "cropName": {
                    "en": "Bromegrass (DM)",
                    "es": "Cebadilla (MS)",
                    "fr": "Brome",
                    "pt": "Cevadilha (MS)",
                    "ru": "Кострец безостый (абсолютно сухое вещество)",
                    "zh": "雀麦草（干物质）"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "cs",
                "cropName": {
                    "en": "Corn silage (67% moisture) per unit of grain yield",
                    "es": "Silaje de Maíz (67% de humedad)",
                    "fr": "Mais ensilage (67% humidité) par unité de rendement grain",
                    "pt": "Silagem de milho (67% de umidade) por unidade de grão colhido",
                    "ru": "Кукуруза на силос (влажность 67%) при планируемой урожайности зерна",
                    "zh": "青储玉米单位产量（67%含水量）"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "bu/A"
                }
            },
            {
                "cropKey": "wr",
                "cropName": {
                    "en": "Rye straw per unit of grain yield",
                    "es": "Centeno, rastrojo por unidad de rendimiento en grano",
                    "fr": "Seigle paille par unité de rendement grain",
                    "pt": "Centeio (palha) por unidade de grão colhido",
                    "ru": "Рожь, солома (при планируемой урожайности зерна)",
                    "zh": "黑麦秸秆单位产量"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "bu/A"
                }
            },
            {
                "cropKey": "ly",
                "cropName": {
                    "en": "Celery",
                    "es": "Apio",
                    "fr": "Céleri",
                    "pt": "Salsão",
                    "ru": "Сельдерей",
                    "zh": "芹菜"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "cwt/A"
                }
            },
            {
                "cropKey": "vb",
                "cropName": {
                    "en": "Soybean stover per unit of grain yield",
                    "es": "Soja, rastrojo por unidad de rendimiento en grano",
                    "fr": "Soja paille par unité de rendement grain",
                    "pt": "Soja (palha) por unidade de grão colhido",
                    "ru": "Соя, солома (при планируемой урожайности зерна)",
                    "zh": "大豆秸秆单位产量"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "bu/A"
                }
            },
            {
                "cropKey": "os",
                "cropName": {
                    "en": "Oat straw per unit of grain yield",
                    "es": "Avena, rastrojo por unidad de rendimiento en grano",
                    "fr": "Avoine paille par unité de rendement grain",
                    "pt": "Aveia (palha) por unidade de grão colhido",
                    "ru": "Овес, солома (при планируемой урожайности зерна)",
                    "zh": "燕麦秸秆的单位产量"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "bu/A"
                }
            },
            {
                "cropKey": "sq",
                "cropName": {
                    "en": "Squash",
                    "es": "Calabacín",
                    "fr": "Courge",
                    "pt": "Abobrinha de moita",
                    "ru": "Тыквенные овощные культуры (кроме огурца)",
                    "zh": "西葫芦"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "cwt/A"
                }
            },
            {
                "cropKey": "sw",
                "cropName": {
                    "en": "Sweet potatoes",
                    "es": "Batatas",
                    "fr": "Patates douces",
                    "pt": "Batata doce",
                    "ru": "Батат",
                    "zh": "甘薯"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "cwt/A"
                }
            },
            {
                "cropKey": "ft",
                "cropName": {
                    "en": "Birdsfoot trefoil (DM)",
                    "es": "Lotus corniculatus",
                    "fr": "Lotier",
                    "pt": "Lotus corniculatus",
                    "ru": "Лядвенец рогатый (абсолютно сухое вещество)",
                    "zh": "百脉根（干物质）"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "co",
                "cropName": {
                    "en": "Cotton stover",
                    "es": "Algodón, rastrojo",
                    "fr": "Paille de coton",
                    "pt": "Algodão (palha)",
                    "ru": "Хлопчатник, стебли",
                    "zh": "棉花秸秆"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "bg",
                "cropName": {
                    "en": "Bermudagrass",
                    "es": "Pasto Bermuda",
                    "fr": "Chiendent",
                    "pt": "Capim Bermuda",
                    "ru": "Свинорой",
                    "zh": "狗牙草"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "ty",
                "cropName": {
                    "en": "Timothy grass (DM)",
                    "es": "Phleum pratense",
                    "fr": "Fléole des prés (MS)",
                    "pt": "Phleum pratense (MS)",
                    "ru": "Тимофеевка луговая (абсолютно сухое вещество)",
                    "zh": "猫尾草（干物质）"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "cg",
                "cropName": {
                    "en": "Corn silage (67% moisture)",
                    "es": "Silaje de Maíz (67% de humedad)",
                    "fr": "Mais ensilage (67% humidité)",
                    "pt": "Silagem de milho (67% de umidade)",
                    "ru": "Кукуруза на силос (влажность 67%)",
                    "zh": "青储玉米（67%含水量）"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "ap",
                "cropName": {
                    "en": "Apples",
                    "es": "Manzanas",
                    "fr": "Pommes",
                    "pt": "Maçã",
                    "ru": "Яблоня, плоды",
                    "zh": "苹果"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "ph",
                "cropName": {
                    "en": "Peaches",
                    "es": "Duraznos",
                    "fr": "Pêches",
                    "pt": "Pêssego",
                    "ru": "Персик",
                    "zh": "桃"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "wt",
                "cropName": {
                    "en": "Wheat straw",
                    "es": "Trigo, rastrojo",
                    "fr": "Blé paille",
                    "pt": "Trigo (palha)",
                    "ru": "Пшеница, солома",
                    "zh": "小麦秸秆"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            },
            {
                "cropKey": "bh",
                "cropName": {
                    "en": "Bahiagrass",
                    "es": "Pasto Bahía",
                    "fr": "Herbe de Bahia",
                    "pt": "Capim Bahia",
                    "ru": "Гречишка заметная",
                    "zh": "巴哈雀稗"
                },
                "mathUnit": {
                    "m": "t/ha",
                    "i": "ton/A"
                }
            }
        ]
    }
